import { useStaticQuery, graphql } from "gatsby"
const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            siteId
            API_SITE_URL
            facebook
            facebookLink
          }
        }
      }
    `
  )
  return site.siteMetadata
}

export default useSiteMetadata
